import { render, staticRenderFns } from "./SessionView.vue?vue&type=template&id=4511b376&"
import script from "./SessionView.vue?vue&type=script&lang=js&"
export * from "./SessionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports